import { SyntheticEvent } from 'react';
import { useParams } from 'react-router-dom';

import { Button, Modal, Typography } from 'antd';

import { getCdnUrl } from '@/helpers';
import { useAppSelector } from '@/hooks/redux';
import { useLog } from '@/hooks/useLog';
import { useUpsell } from '@/hooks/useUpsell';
import { IUpsell } from '@/interfaces/upsell';
import { coursesApi } from '@/services/course';
import styled, { StyledProp } from '@/styled';

interface IProps extends StyledProp {
  data: IUpsell;
  isLoading: boolean;
  open: boolean;
  onCancel: () => void;
}

const UpsellModal = (props: IProps) => {
  const { hash } = useParams<{ hash: string }>();
  const user = useAppSelector(store => store.auth.user);
  const { log } = useLog();
  const { data: course } = coursesApi.endpoints.getCourse.useQueryState(hash, { skip: !hash });
  const { totalModules } = coursesApi.endpoints.getModules.useQueryState(
    { courseHash: hash },
    {
      skip: !hash,
      selectFromResult: result => ({ totalModules: result.data?.data?.length ?? 0 })
    }
  );
  const openUpsell = useUpsell(props.data, { utm_medium: 'curso' });

  const handleSubmit = (event: SyntheticEvent) => {
    openUpsell(event);
    log('upsellnew', {
      action: 'view',
      id: props.data?.id,
      hash_checkout: props.data?.content,
      viewd: 'page_course',
      producer_id: props.data?.producer_id,
      user_id: user?.id
    });
  };

  const footer = [
    <Button key='back' onClick={props.onCancel} loading={props.isLoading} size='large'>
      Cancelar
    </Button>,
    <Button key='submit' type='primary' loading={props.isLoading} onClick={handleSubmit} size='large'>
      {props.data?.label_text ?? 'Saiba Mais'}
    </Button>
  ];

  return (
    <Modal className={props.className} footer={footer} open={props.open} closable={false} centered>
      <div className='header'>
        <img src={getCdnUrl(props.data?.showcase_image, '')} alt='Imagem da oferta' />
        <div>
          <Typography.Title level={4} ellipsis={{ rows: 3 }}>
            {props.data?.title}
          </Typography.Title>
        </div>
      </div>

      <Typography.Paragraph ellipsis={{ rows: 5 }}>{props.data?.description}</Typography.Paragraph>
    </Modal>
  );
};

export default styled(UpsellModal)`
  max-width: 600;
  width: 100%;

  .ant-modal-body {
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.space.pxToRem(29)};
  }

  .ant-modal-footer {
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
    gap: ${({ theme }) => theme.space.pxToRem(8)};

    button {
      margin-inline-start: 0;
      ${({ theme }) => theme.breakpoints.up('md')} {
        width: fit-content;
      }
    }
  }

  .header {
    display: flex;
    gap: ${({ theme }) => theme.space.pxToRem(29)};

    > img {
      max-width: 140px;
      max-height: 140px;
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: ${({ theme }) => theme.borderRadius}px;

      ${({ theme }) => theme.breakpoints.down('md')} {
        display: none;
      }
    }
  }
`;
